(function ($, Drupal) {
    Drupal.behaviors.override = {
        attach: function (context, settings) {
            /*
             * @description adding code to modify element attributes on after DOM is ready.
             */
            // jQuery(document).ready(function() {
            //   var empowerMeHeaderLogo = document.querySelector('.brand-banner__inner img');
            //   empowerMeHeaderLogo.setAttribute('height','72');
            //   empowerMeHeaderLogo.setAttribute('width','482');
            //   var empowerMeFooterLogo = document.querySelector('.gds-footer__branding .gds-footer__logo-bi img');
            //   empowerMeFooterLogo.setAttribute('height','56');
            //   empowerMeFooterLogo.setAttribute('width','113');

            // });

            jQuery('a[data-it-button="English"]').off("click");
            jQuery("html").attr("lang", "en-US");
            /* Add hreflang in anchor link */
            // jQuery('link, a').each(
            //     function() {
            //         jQuery(this).attr('hreflang', 'en-US');
            //     }
            // );

            $("a").each(function () {
                if ($(this).attr("target") == "_blank") {
                    $(this).attr("rel", "noopener noreferrer");
                }
            });

            jQuery("button#rate_this_button").attr(
		{
          		'title': 'Rate this Site',
          		'data-it-button': 'rate-this-site'
        	}
            );

            jQuery(document).ready(function () {
                // Hide textarea initially
                jQuery('.gds-form-input[data-type="textarea"]').hide();

                // Listen for changes in the dropdown
                jQuery("select#edit-howdidyouhear")
                    .on("change", function () {
                        var selectedMethod = jQuery(this).val();

                        if (selectedMethod === "other") {
                            jQuery('.gds-form-input[data-type="textarea"]').show(); // Show wrapper
                            jQuery('.gds-form-input[data-type="textarea"] textarea').show(); // Show textarea
                        } else {
                            jQuery('.gds-form-input[data-type="textarea"]').hide(); // Hide wrapper
                            jQuery('.gds-form-input[data-type="textarea"] textarea').hide(); // Hide textarea
                        }
                    })
                    .trigger("change"); // Apply logic on page load
            });

            document.addEventListener("DOMContentLoaded", function () {
                setTimeout(() => {
                    let messageDiv = document.querySelector("div[data-drupal-messages]");
                    let targetDiv = document.querySelector(".layout--onecol");
                    if (messageDiv && targetDiv) {
                        targetDiv.prepend(messageDiv);
                    }
                }, 500);
            });

            $(document).ready(function () {
                var baseUrl = window.location.origin + drupalSettings.path.baseUrl;
                $(".brand-banner__product-picture").wrap(
                    '<a href="' + baseUrl + '"></a>'
                );
            });

            const radios = document.querySelectorAll('[type="radio"]');

            radios.forEach(function (radio) {
                radio.addEventListener("click", function () {
                    radios.forEach((r) => r.classList.add("selected"));
                });
            });

            jQuery(document).delegate('.select2-results__option', 'mouseenter focus', function() {
                jQuery(this).removeClass('select2-results__option--highlighted')
            });



        }
    };

})(jQuery, Drupal);
